import { useState } from 'react'
import { subscribeToMailchimpList } from 'shared-utilities'
import InputButtonCombo2026 from '../../InputButtonCombo2026/InputButtonCombo2026'
import FooterContent from '../../../content/footer'

const NewsletterForm = () => {
  const [email, setEmail] = useState<string>('')
  const [mailchimpResponse, setMailchimpResponse] = useState<{
    status: string
    message: string
  }>({
    status: '',
    message: '',
  })

  const handleSubscribe = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (
      FooterContent.mailChimp.baseURL &&
      FooterContent.mailChimp.mailingList
    ) {
      subscribeToMailchimpList(
        { EMAIL: email },
        FooterContent.mailChimp.baseURL,
        FooterContent.mailChimp.mailingList,
        (status: string, message: string) =>
          setMailchimpResponse({ status, message })
      )
    }
  }

  return (
    <>
      <InputButtonCombo2026
        id="email-input"
        name="newsLetterForm"
        type="email"
        placeholder="Enter your email"
        buttonText="Submit"
        value={email}
        required
        onChange={setEmail}
        onSubmit={handleSubscribe}
      />
      {mailchimpResponse.status === 'error' && (
        <div className="pl-4 pt-4">
          <span className="text-error-1">{mailchimpResponse.message}</span>
        </div>
      )}
      {mailchimpResponse.status === 'success' && (
        <div className="pl-4 pt-4">
          <span>{mailchimpResponse.message}</span>
        </div>
      )}
    </>
  )
}

export default NewsletterForm
